import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeControllerService {
    
  constructor() { }
  
  getThemeBasedOnDomain(cid: any, imgHubLink: any){
    /* Set Company colors based on domain */
    var domain = cid;
    document.body.setAttribute('data-id', domain);
    document.documentElement.setAttribute('data-id', domain);
    /* Set Company Logo */
    const head = document.head || document.getElementsByTagName('head')[0];
    const newFaviconElement = document.getElementById('dynamic-favicon') as HTMLLinkElement;
    
    /* Set Company Title , and Company Logo */
    switch(domain){
      case 'MWP105':
        document.title = 'WB Trade ' + document.title;
        newFaviconElement.href = `${imgHubLink}/assets/images/wb-dark-logo.svg`;
        break;
      case 'MWM230':
        document.title = 'WM Markets ' + document.title;
        newFaviconElement.href = `${imgHubLink}/assets/images/wm.svg`;
        break;
      case 'MUH864':
      case 'CUH689':
        document.title = 'Windsor Brokers ' + document.title;
        newFaviconElement.href = `${imgHubLink}/assets/images/wb-dark-logo.svg`;
        break;
      case 'WBI483':
        document.title = 'WB Invest ' + document.title;
        newFaviconElement.href = `${imgHubLink}/assets/images/wbi-menu-darklogo.svg`;
        break;
      default:
        document.title = document.title;
        newFaviconElement.href = `${imgHubLink}/assets/images/logo-placeholder-image.png`;
        break;
    }
    head.appendChild(newFaviconElement);
  }
  
}
